<template>
  <div class="slate-int-calculator-transition">
    <img src=".././assets/transition.svg" />
  </div>
</template>

<script>
export default {
  name: 'hello',
  props: ['fields'],
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.slate-int-calculator-transition {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.2);;
}
img {
  width: 10%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// CalculatorTransition.vue?4e717fe2